module.exports = __webpack_public_path__ + "img/veryhigh.12d2ee89.svg";